module.exports = __webpack_public_path__ + "static/media/bilge.dc8861f5.jpg";